import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceDuplicateProjectNotificationState = createStateReducer(
  initialState,
  {
    [events.duplicateProjectSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "duplicateProject",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.duplicateProjectFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "duplicateProject",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceDuplicateProjectNotificationState };
